import * as types from "../actions/types";


const initialState = {
    isOpen: false,
    title: "",
    boldText: "",
    description: "",
    hideClose: false,
    primaryLabel: "",
    secondaryLabel: "",
    textFieldLabel: null,
    onPrimaryAction: () => {},
    onSecondaryAction: () => {},
    clickOutsideToClose: true
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.OPEN_ALERTDIALOG:
            console.log("OPEN_ALERTDIALOG");
            return Object.assign({}, state, {
                title: action.payload.title || "",
                boldText: action.payload.boldText,
                description: action.payload.description,
                hideClose: action.payload.hideClose,
                secondaryLabel: action.payload.secondaryLabel || "",
                primaryLabel: action.payload.primaryLabel,
                textFieldLabel: action.payload.textFieldLabel,
                textFieldContent: action.payload.textFieldContent,
                onPrimaryAction: action.payload.onPrimaryAction ? action.payload.onPrimaryAction : () => {},
                onSecondaryAction: action.payload.onSecondaryAction ? action.payload.onSecondaryAction : () => {},
                isOpen: true,
                clickOutsideToClose: action.payload.clickOutsideToClose === false ? false : true
            });
        case types.CLOSE_ALERTDIALOG:
            return Object.assign({}, state, {
                isOpen: false
            });
        case types.CLEAR_DIALOG:
            return Object.assign({}, state, {
                title: "",
                boldText: "",
                description: "",
                hideClose: false,
                secondaryLabel: "",
                primaryLabel: "",
                textFieldLabel: null,
                onPrimaryAction: () => {},
                onSecondaryAction: () => {},
                clickOutsideToClose: true
            });

        default:
            return state;
    }
};
